import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import dayjs from "dayjs";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const inOutLogReportList = createAsyncThunk('inOutLogReport/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `inout_log_report`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const generateInOutLogReport = createAsyncThunk('inOutLogReport/generate', async ({ values }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + `inout_log_report/excel`,
            data: {
                premise_id: values?.premise,
                type_id: values?.type,
                sub_type_id: values?.sub_type,
                from_date: values?.from_date && dayjs(values?.from_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                to_date: values?.to_date && dayjs(values?.to_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                status: values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const inOutLogReportSlice = createSlice({
    name: 'inOutLogReport',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(inOutLogReportList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }
        });
        builder.addCase(inOutLogReportList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default inOutLogReportSlice.reducer;